<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <mat-toolbar color="" class="topbar telative">
    <button
      *ngIf="isMobile"
      mat-icon-button
      type="button"
      (click)="snav.toggle()"
      [attr.aria-label]="snav.opened ? 'Cerrar menú' : 'Abrir menú'"
      [attr.aria-expanded]="snav.opened"
      aria-controls="snav"
    >
      <mat-icon>{{ snav.opened ? 'close' : 'menu' }}</mat-icon>
    </button>
    <!-- ============================================================== -->
    <!-- Logo - style you can find in header.scss -->
    <!-- ============================================================== -->
    <div class="navbar-header">
      <a class="navbar-brand" href="index.html">
        <!--End Logo icon -->
        <!-- Logo text -->
        <span class="text-logo-icon" fxShow="false" fxShow.gt-xs>
          <!-- Light Logo text -->
          <img src="assets/images/kluby-fit-logo-dark.png" alt="Kluby Fit" class="light-logo" />
        </span>
      </a>
    </div>
    <!-- ============================================================== -->
    <!-- app header component - style you can find in header.scss / header.component.ts-->
    <!-- ============================================================== -->
    <app-header class="d-flex align-items-center ml-auto"></app-header>
  </mat-toolbar>
  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <mat-sidenav-container
    class="example-sidenav-container"
    [style.--sidebar-content-offset]="mobileQuery.matches ? (isSidebarCompact ? '72px' : '240px') : '0px'"
  >
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav
      #snav
      id="snav"
      class="dark-sidebar pl-xs"
      [class.sidebar--compact]="mobileQuery.matches && isSidebarCompact"
      [style.width.px]="mobileQuery.matches && isSidebarCompact ? 72 : 240"
      [mode]="mobileQuery.matches ? 'side' : 'over'"
      fixedTopGap="0"
      [opened]="mobileQuery.matches"
      [disableClose]="mobileQuery.matches"
    >
      <app-sidebar
        [compact]="mobileQuery.matches && isSidebarCompact"
        [showCompactToggle]="mobileQuery.matches"
        (compactChange)="isSidebarCompact = $event"
        (navigationSelected)="onNavigationSelected(snav)"
      ></app-sidebar>
    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper">
      <div class="page-content">
        <router-outlet><app-spinner></app-spinner></router-outlet>
      </div>
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>
